'use strict';

const mixpanel = require('mixpanel-browser');
const TRACK_EVENTS = true;
window.mixpanel = mixpanel;
const TOKEN = globalVars.MIXPANEL_TOKEN;
const DEBUG = globalVars.MIXPANEL_DEBUG;
const USER_EVENTS_TRACKING_TOGGLE = globalVars.USER_EVENTS_TRACKING_TOGGLE;
const USER_RECORD_SESSION_PERCENT = globalVars.USER_RECORD_SESSION_PERCENT || 0;
const DEFAULT_CONFIG = {
    debug: DEBUG,
    api_host: '/api/tracking',
    api_hosts: {
        engage: 'https://api-js.mixpanel.com',
        record: 'https://api-js.mixpanel.com',
    },
    track: TRACK_EVENTS,
    track_pageview: true, // TODO set to false if you want to have session replay only on some pages
    batch_requests: true,
    batch_size: 50,
    batch_flush_interval_ms: 5000,
    batch_request_timeout_ms: 90000,
    batch_autostart: true,
    persistence: 'localStorage',
    record_sessions_percent: USER_RECORD_SESSION_PERCENT, // Percentage of users to record sessions for (0-100)
    record_idle_timeout_ms: 240000, // End a replay capture after time of inactivity (240000ms = 4 minutes)
    record_heatmap_data: globalVars.USER_HEATMAP_TRACKING_TOGGLE, // Enable Heatmap data collection | requires record_sessions_percent > 0
    record_mask_text_selector: '', //unmask all text elements
    record_block_selector: '', //unmask images and videos
};

const originalTrack = mixpanel.track;

mixpanel.track = function (event, properties, ...args) {
    if (!properties.type && event.startsWith('$')) {
        // set type for automatic events
        properties = { ...properties, type: 'b2b_mixpanel' };
    }
    return originalTrack.call(this, event, properties, ...args);
};

const waitForUser = () => {
    return new Promise((resolve) => {
        const checkUser = () => {
            const uuidAgent = window?.gtxLoggedUser?.agentUuid;
            if (uuidAgent) {
                resolve(uuidAgent);
            } else {
                setTimeout(checkUser, 500); // retry each 500ms
            }
        };
        checkUser();
    });
};

const initializeMixpanel = async (config) => {
    try {
        const sensitivePages = ['/login', '/signin', '/signup'];
        const currentPath = window.location.pathname;
        if (sensitivePages.some((page) => currentPath.includes(page))) {
            return;
        }

        const uuidAgent = await waitForUser();

        mixpanel.init(TOKEN, {
            ...DEFAULT_CONFIG,
            ...config,
            uuidAgent,
            loaded: function (mixpanelLoaded) {
                mixpanelLoaded.identify(mixpanelLoaded.config.uuidAgent);
            },
        });
    } catch (error) {
        console.error('Failed to initialize Mixpanel:', error);
    }
};

module.exports = {
    events_track_type: {
        B2B_SOCIALS: 'b2b_socials',
        B2B_SETTINGS: 'b2b_settings',
        B2B_PROPERTY: 'b2b_property',
    },
    source_type: {
        APP: 'gestionale',
        EMAIL: 'email',
        PUSH: 'push',
    },
    track: function (event, payload) {
        if (!USER_EVENTS_TRACKING_TOGGLE || !DEFAULT_CONFIG.track) {
            return;
        }

        mixpanel.track(event, payload);
    },
    init: function (config) {
        if (USER_EVENTS_TRACKING_TOGGLE) {
            initializeMixpanel(config);
        }
    },
    ['get_session_recording_properties']: function () {
        return mixpanel.get_session_recording_properties();
    },
};
